export default "__VITE_ASSET__Ca_MFqUu__"